import { render, staticRenderFns } from "./ImportMapsInsurerParticipants.vue?vue&type=template&id=1b0cde51&scoped=true&"
import script from "./ImportMapsInsurerParticipants.vue?vue&type=script&lang=js&"
export * from "./ImportMapsInsurerParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0cde51",
  null
  
)

export default component.exports